import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogService } from './dialog.service';

@Component({
  selector: 'dialog-container',
  template: '<dialog-ref #ref></dialog-ref>'
})
export class DialogContainerComponent implements AfterViewInit {
  @ViewChild('ref', {read: ViewContainerRef, static: false})
  containerRef: ViewContainerRef;

  constructor(private dialogService: DialogService) {
  }

  ngAfterViewInit(): void {
    this.dialogService.setViewContainer(this.containerRef);
  }

}
